import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { App } from "@capacitor/app";
import { Platform } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { CurrentSessionData } from "src/model/class/general classes/current-session-data";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { SecuretyDataProtectionService } from "src/service/securety-data-protection.service";
import { ThemeService } from "src/service/theme.service";
import { currentUserData } from "src/state/selectors/authentication.selectors";

@Component({
    selector: "app-menu-web",
    templateUrl: "./menu-web.component.html",
    styleUrls: ["./menu-web.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuWebComponent implements OnInit, OnDestroy {
  //#region Subcriptions to "_store.select(...)" Observables
  private _selectCurrentUserSub: Subscription = null;
  //#endregion

  public userUsername: string = "";
  public currentUser: CurrentSessionData = null;
  public cssVersionClass: string = "";

  public appVersion: string = "";
  public isLargeScreen: boolean = false;
  public isApp: boolean = false;
  public isAppAndroid: boolean = false;
  public enumBIGDeviceOperationMode = BIGDeviceOperationMode;
  public isBigStudio: boolean = false;
  public isNemo: boolean = false;
  public isDigitalPlace: boolean = false;

  constructor(
    private _platform: Platform,
    private _themeService: ThemeService,
    private _store: Store,
    private _securetyDataProtectionService: SecuretyDataProtectionService
  ) {
    this.isApp = this._platform.is("android") || this._platform.is("ios");
    this.isAppAndroid = this._platform.is("android");
    this.isLargeScreen = this._platform.width() >= 768;
  }

  async ngOnInit() {
    this.getCurrentTheme();
    this.loadAppVersion();
    this.loadCurrentUserData();
  }

  ngOnDestroy() {
    this._selectCurrentUserSub.unsubscribe();
  }

  /**
   * Load current user data
   */
  private loadCurrentUserData(): void {
    this._selectCurrentUserSub = this._store
      .select(currentUserData)

      .pipe(
        filter((currentUserData: GenericUserData) => currentUserData !== null),
        map((currentUserData: GenericUserData) => currentUserData?.currentUser)
      )
      .subscribe((currentUser: CurrentSessionData) => {
        this.currentUser = currentUser;

        if (currentUser != null) {
          this.userUsername = this._securetyDataProtectionService.decypt(
            currentUser.username,
            null
          );
        }
      });
  }



  //#endregion

  /**
   * Load appliceation version
   */
  private async loadAppVersion(): Promise<void> {
    try {
      this.appVersion = (await App.getInfo()).version;

      if (this.appVersion) {
        this.cssVersionClass = "with-version";
      }
    } catch (ex) { }
  }

  /**
   * Get current theme and set variabile to show/hide video of bigstudio on left
   */
  private getCurrentTheme() {

    switch (this._themeService.applicationTheme) {

      case ApplicationTheme.BLUMOTIX:
        this.isNemo = true;
        break;
      case ApplicationTheme.DIGITAL_PLACE:
        this.isDigitalPlace = true;
        break;
      case ApplicationTheme.BIG:
      default:
        this.isBigStudio = true;
        break;

    }
  }
}
